// extracted by mini-css-extract-plugin
export default {"main":"_2ba9af8345","tit":"d0fa94527d","maintitle":"_11e1a84ab1","ylw":"_4a1e43e736","white":"_047e6265c4","mv_title":"_7149431a89","mv_nc":"_19b8c65efb","mv_in":"_6487c1573e"};